import { render } from "./index.vue?vue&type=template&id=6e04f578&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6e04f578&lang=less&scoped=true"

import exportComponent from "E:\\Voyager_Project\\SourceCode\\Front_End\\dev_version_Voyager\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e04f578"]])

export default __exports__